
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/cua-hang/[providerId]",
      function () {
        return require("private-next-pages/default/desktop/cua-hang/[providerId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/cua-hang/[providerId]"])
      });
    }
  